import cn from 'classnames';
import { Field, useFormikContext } from 'formik';
import { useState, useEffect } from 'react';

import FormField from 'components/common/FormField';
import Text from 'components/common/Text';
import SmsLegalText from 'components/signUpFunnel/shared/SmsLegalText';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const IntroSmsOptIn = () => {
  const { handleChange, values, touched, errors, handleBlur } = useFormikContext();
  const [displayPhone, setDisplayPhone] = useState(false);
  const isTempo = useBrand(TEMPO);

  useEffect(() => {
    setDisplayPhone(values.introSmsOptIn);
  }, [values.introSmsOptIn]);

  return (
    <>
      <Text className="text-secondary mb-2 mt-0" brandStylesOverrides="textMd">
        Would you like to stay updated via text?
      </Text>
      <label htmlFor="introSmsOptIn" className="block">
        <div className="flex items-start">
          <Field
            type="checkbox"
            name="introSmsOptIn"
            id="introSmsOptIn"
            onChange={async event => {
              handleChange(event);
            }}
            className="mt-1"
          />
          <Text htmlElement="span" className="text-secondary ml-2 text-sm">
            Yes, I want to receive texts about offers, menus, and news from
            {isTempo ? ' Tempo' : ' Home Chef'}.
          </Text>
        </div>
      </label>
      {displayPhone && (
        <div className="mt-4">
          <FormField
            label="Phone Number"
            labelClass="sr-only"
            labelBrandStylesOverrides="textMd"
            containerClass="w-full"
            name="introSmsPhoneNumber"
            type="tel"
            placeholder="1##########"
            inputClass={cn('rounded-2xl border px-6', {
              'border-charcoal-60': isTempo,
              'border-cream-120': !isTempo,
            })}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.introSmsPhoneNumber && errors.introSmsPhoneNumber}
          />
          <SmsLegalText />
        </div>
      )}
    </>
  );
};

export default IntroSmsOptIn;
